<template>
  <div id="waitingForServer">
    <div v-if="this.$store.state.waitingForServer.waiting">
      <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WaitingForServer',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    dismiss() {
      this.$store.dispatch('unsetGlobalMessage');
    },
  },
  computed: {
  },
  watch: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#waitingForServer {
  position: fixed;
  color: white;
  z-index: 500;
  right: 10px;
  top: 15px;
  i {
    text-shadow: 0 0 2px #00695C;
  }
}
</style>



// WEBPACK FOOTER //
// WaitingForServer.vue?7d906b14